import { processEnv } from '../../env.mjs';

/**
 * Folder chứa các thông tin về assets của phần mềm
 */
const ROOT_PATH = `/imgs`;
/**
 * Folder chứa các file ảnh của phần mềm
 */
const folder_path = {
    /**Folder của PSC */
    PSC: 'psc',

    /**icon folder */
    ICONS: 'icons',
};

/**
 * Danh sách các file ảnh của phần mềm
 */
const def_img_path = {
    /**favicon */
    favicon: 'favicon.ico',
    /**Logo chính */
    logo: 'logo.svg',
    sso_logo: 'sso-logo.svg',
    /**Logo chính trong suốt*/
    logo_white_text: 'logo-white-text.png',
    logo_white_big_text: 'logo-white-text.png',
    /**Logo chính nhưng ko có text */
    logo_no_text: 'logo-no-text.png',
    /**logo chính nhưng không có chữ */
    logo_color_no_text: 'logo-color-no-text.png',
    /** */
    bg_header: 'bg_header.png',
    /** */
    bg_auth: 'bg-auth.jpg',
    bg_auth1: 'banner_1.jpg',
    bg_auth2: 'banner_2.jpg',
    bg_auth3: 'banner_3.jpg'
};

/**
 * Lấy đường dẫn ảnh theo folder và có đánh dấu version để tránh cache
 * @param brand
 * @param img_path
 * @returns
 */
const getImgByFolder = (brand: keyof typeof folder_path, img_path: string) => {
    const folder = folder_path[brand];
    const defImgPath =
        def_img_path[img_path as keyof typeof def_img_path] ?? img_path;

    return `${ROOT_PATH}/${folder}/${defImgPath}?v=${processEnv.NEXT_PUBLIC_APP_VERSION ?? '0'}`;
};
/**
 * Lấy đường dẫn ảnh theo folder và có đánh dấu version để tránh cache
 * @param brand
 * @param img_path
 * @returns
 */
const getImgByDefImg = (brand: keyof typeof folder_path, img_path: keyof typeof def_img_path) => {
    const folder = folder_path[brand];
    const defImgPath =
        def_img_path[img_path as keyof typeof def_img_path] ?? img_path;

    return `${ROOT_PATH}/${folder}/${defImgPath}?v=${processEnv.NEXT_PUBLIC_APP_VERSION ?? '0'}`;
};

/**
 *
 * Lưu thông tin các path assets file của nextjs tại đây
 */
export const APP_ASSETS = {
    /**favicon — no cache-busting query string, browsers require clean ico URLs */
    FAVICON: `${ROOT_PATH}/${folder_path.PSC}/${def_img_path.favicon}`,

    /**Logo mặc định của phần mềm */
    LOGO: getImgByDefImg('PSC', 'logo'),
    LOGO_WHITE_TEXT: getImgByDefImg('PSC', 'logo_white_text'),
    LOGO_WHITE_BIG_TEXT: getImgByDefImg('PSC', 'logo_white_big_text'),

    /**Logo chỉ hình ảnh */
    LOGO_NO_TEXT: getImgByDefImg('PSC', 'logo_no_text'),

    /** */
    LOGO_COLOR_NO_TEXT: getImgByDefImg('PSC', 'logo_color_no_text'),

    /**Background của header nếu có */
    BG_HEADER: getImgByDefImg('PSC', 'bg_header'),

    /**Background sử dugnj trong các trang auth(signin, signup, ....) */
    BG_AUTH: getImgByDefImg('PSC', 'bg_auth'),

    LIST_BG_AUTH: [
        getImgByDefImg('PSC', 'bg_auth1'),
        getImgByDefImg('PSC', 'bg_auth2'),
        getImgByDefImg('PSC', 'bg_auth3'),
    ],
    LIST_BG_AUTH_LOW_RES: [
    ],
    LIST_BG_AUTH_LOWEST_RES: [
    ],
};

/**
 * Lưu thông tin các icon của phần mềm
 */
export const ICONS = {
    '365': getImgByFolder('ICONS', 'logo-365.svg'),
    google: getImgByFolder('ICONS', 'logo-google.svg'),
    adfs: getImgByFolder('ICONS', 'logo-adfs.svg'),
    sso_book: getImgByFolder('ICONS', 'sso-logo-book.svg'),
    sso_shield: getImgByFolder('ICONS', 'sso-logo-shield.svg'),
    sso_key: getImgByFolder('ICONS', 'sso-logo-key.svg'),
    sso: getImgByDefImg('PSC', 'sso_logo'),
    // sso: getImgByFolder('ICONS', 'sso-logo-key.svg'),
};
